import { useRef, useEffect, useState } from 'react';
const useConditionalMemo = (factory, dependencies, keepStale = false) => {
    const [value, setValue] = useState(() => factory());
    const depsRef = useRef(dependencies);
    useEffect(() => {
        const depsChanged = dependencies.some((dep, index) => dep !== depsRef.current[index]);
        if (depsChanged && !keepStale) {
            setValue(factory());
        }
        depsRef.current = dependencies;
    }, [...dependencies, keepStale]);
    return value;
};
export default useConditionalMemo;
